// extracted by mini-css-extract-plugin
export default {"pie_chart":"piechart_pie_chart__fRlzZ","total":"piechart_total__rdGlj"};